import { RoleBasedDashboard } from '@/features/dashboard/components';
import { resolveDashboardRole } from '@/features/dashboard/lib/backend-role-map';
import { useAuthStore } from '@/stores/auth-store';
import { useTranslation } from '@kgc/i18n';

/**
 * Dashboard Page
 * Uses RoleBasedDashboard to render widgets based on user role
 */
export function DashboardPage() {
  const { t } = useTranslation();
  const { user } = useAuthStore();

  // A BE `Role` -> dashboard-szerep feloldás EXPLICIT térképből (QA-100).
  // A korábbi `as UserRole` cast némán átengedte a BOLTVEZETO-t, amire se layout,
  // se widget-szabály nem illeszkedett -> a boltvezető 37-ből 3 widgetet kapott.
  const userRole = resolveDashboardRole(user?.role);

  return (
    <div className="min-h-full p-6 kgc-bg">
      {/* Welcome */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          {t('dashboard.welcome', {
            name: user?.name?.split(' ')[0] || t('dashboard.defaultUser'),
          })}
        </h1>
        <p className="text-gray-600 dark:text-gray-400">{t('dashboard.todaySummary')}</p>
      </div>

      {/* Role-Based Dashboard Widgets */}
      <RoleBasedDashboard userRole={userRole} />
    </div>
  );
}
